import { useMemo } from "react";
import { Endpoints, queryKeys } from "../api";
import { useAuth } from "../contexts";
import { useAxios, useGenericQuery } from "../hooks";
import { SurgeonWithTissues, TissueReportSlugs } from "../models";

interface TissueReportQueryParams {
    startDate?: string;
    endDate?: string;
    reportName?: TissueReportSlugs;
    includeSent?: boolean;
}

export const useTissueReportQuery = ({
    startDate,
    endDate,
    reportName,
    includeSent,
}: Readonly<TissueReportQueryParams>) => {
    const { get } = useAxios();
    const { isAuthorized } = useAuth();
    const url = Endpoints.TissueReports;

    const query = useGenericQuery({
        queryFn: (config) =>
            get<SurgeonWithTissues[]>({
                url: `${url}/${reportName}?startDate=${startDate}&endDate=${endDate}&includeSent=${includeSent?.toString() ?? "false"}`,
                config,
            }),
        queryKey: queryKeys.tissueReports.list({ reportName, startDate, endDate, includeSent }),
        placeholderData: [],
        enabled: isAuthorized && !!reportName && !!startDate && !!endDate,
        staleTime: 5000,
        cacheTime: 5000,
    });

    return useMemo(() => ({ query }), [query]);
};
